export default () => ({
  registration: {
    attachment: {
      content: null,
      mime: null
    },
    name: null,
    entity_id: null,
    country_register: null,
    state: null,
    document: null,
    record: null,
    birthdate: null,
    networks: {
      linkedin: null,
      lattes: null
    }
  },
  errors: {}
})



// WEBPACK FOOTER //
// ./src/app/employee/record/registration/resources/data.js